module.exports = __webpack_public_path__ + "static/media/points-bottom-left.ddd15a90.svg";